import { createContext, useContext } from "react";

export interface AuthUser {
	id: string;
	email: string;
	is_super_admin: boolean;
}

export interface AuthContextValue {
	user: AuthUser | null;
	isLoading: boolean;
	refresh: () => Promise<void>;
	logout: () => void;
}

export const AuthContext = createContext<AuthContextValue | null>(null);

export function useAuth(): AuthContextValue {
	const ctx = useContext(AuthContext);
	if (!ctx) throw new Error("useAuth must be used within AuthProvider");
	return ctx;
}
